<template>
    <section class="layout">
        <div
            :class="{
                'header nav-header flex justify-between items-center pl-4 pr-6 py-2': true,
                'nav-animate': navAnimate
            }"
            style=""
        >
            <HeaderLogo
                :logoWidth="logoWidth"
                :mobileLogoWidth="MobileLogoWitdh"
                color="var(--ui-primary-color)"
                shadow="var(--text-shadow-color)"
                class="inline-block logo md:mt-2"
            ></HeaderLogo>
            <TopRightMenu
                v-if="!hideTopRightMenu"
                :login-status="loginStatus"
                @click-your-quiz-link="clickToMyQuiz()"
                @click-new-quiz="clickNewQuiz()"
                @click-edit-profile="clickEditProfile()"
                @click-order="clickOrder()"
                @click-subscribe-plan="clickSubscribePlan()"
                @click-subpage="clickSubpage"
                @click-buy-credit="clickBuyCredit()"
                @open-auth-popup="showAuthPopup = true"
                @clear-intro="onClearIntro"
            />
        </div>
        <div style="margin-top: 5rem; padding-bottom: 2rem">
            <slot></slot>
        </div>
        <Footer v-if="isShowFooter()" logo-color="var(--ui-color)" />
        <div>
            <AuthPopup
                v-if="showAuthPopup"
                ref="authPopup"
                :unsubscribe="unsubscribe"
                :webview-redirect-to="createWebviewRedirectTo()"
                @login-success="loginSuccess"
                @register-success="loginSuccess"
                @close="showAuthPopup = false"
            />
        </div>
    </section>
</template>

<script>
import AuthPopupMixin from '@/mixins/auth-popup'
import TopRightMenu from '@/components/TopRightMenu'
import AuthPopup from '@/components/AuthPopup'
import HeaderLogo from '@/components/HeaderLogo.vue'
import Footer from '@/components/Footer'
import { nuxtUrl } from '@/lib/nuxt-url.js'

export default {
    name: 'UserPageLayout',

    props: {
        navAnimate: {
            type: Boolean,
            default: false
        },

        hideTopRightMenu: {
            type: Boolean,
            default: false
        },

        unsubscribe: {
            type: Boolean,
            default: false
        }
    },

    mixins: [AuthPopupMixin],

    components: {
        TopRightMenu,
        AuthPopup,
        HeaderLogo,
        Footer
    },

    data() {
        return {
            logoWidth: 12,
            MobileLogoWitdh: 9,
            lastScrollTop: 0
        }
    },

    mounted() {
        if (this.unsubscribe) {
            this.showAuthPopup = true
        }
        const self = this
        document.getElementById('app').addEventListener('scroll', () => {
            var scrollTop = document.getElementById('app').scrollTop
            var nav = document.querySelector('.nav-header')
            const windowWidth = window.innerWidth
            const isSmallDevice = windowWidth < 720
            const breakPoint = isSmallDevice ? 30 : 50

            if (scrollTop <= 0) {
                document.querySelector('.nav-header')
                    ? document.querySelector('.nav-header').classList.remove('hide')
                    : null
                self.lastScrollTop = 0
                return
            }

            if (Math.round(scrollTop) > Math.round(self.lastScrollTop)) {
                document.querySelector('.nav-header').classList.add('hide')
                self.lastScrollTop = scrollTop
            } else if (Math.round(scrollTop) < Math.round(self.lastScrollTop)) {
                document.querySelector('.nav-header').classList.remove('hide')
                self.lastScrollTop = scrollTop
            }

            if (nav) {
                var logo = nav.querySelector('img')

                if (scrollTop > breakPoint) {
                    nav.style.background = 'var(--background-color)'
                    logo.style.maxWidth = `${self.MobileLogoWitdh}rem`
                } else {
                    nav.style.background = 'transparent'
                    logo.style.maxWidth =
                        window.innerWidth > 767 ? `${self.logoWidth}rem` : `${self.MobileLogoWitdh}rem`
                }
            }
        })

        window.addEventListener('feide-login-success', e => {
            if (this.getIsStudentRoles()) {
                window.location.href = nuxtUrl('/skoler/join')
            }

            this.loginStatus = true
            this.afterLoginSuccess(e.detail)
        })
    },

    methods: {
        afterLoginSuccess(user) {
            if (user) {
                this.$emit('login-success', true)
            }
        },

        triggerOpenNewsletter() {
            this.showAuthPopup = true
            this.$nextTick(() => {
                this.$refs.authPopup.openNewsletterModal()
                this.$router.push(this.$route.path)
            })
        },

        onClearIntro() {
            this.$emit('clear-intro')
        },

        isShowFooter() {
            // Add route name to show here.
            const pathNames = ['purchase', 'skoler-purchase', 'school-purchase']

            if (pathNames.includes(this.$route.name)) return true

            return false
        }
    }
}
</script>

<style lang="scss">
.nav-header {
    position: fixed;
    z-index: 99;
    background: transparent;
    width: 100%;
    top: 0;
    left: 0;
    transition: all 0.2s ease;

    img {
        transition: all 0.2s ease;
    }
}

@media screen and (min-width: 768px) {
    .nav-header {
        &.hide {
            transform: translateY(-100px);
        }

        &.nav-animate {
            transform: translateY(0px);
        }
    }
}
</style>
